import { Pipe, PipeTransform } from '@angular/core';
import { FeatureName } from 'src/app/common/feature-name';

@Pipe({
  name: 'featurePopover',
  standalone: true
})
export class FeaturePopoverPipe implements PipeTransform {
  transform(feature: string | null | undefined): string {
    const normalized = (feature ?? '').trim();

    switch (normalized) {
      case FeatureName.Kunder:
        return 'Åbn kunde';
      case FeatureName.Skabeloner:
        return 'Åbn skabelon';
      case FeatureName.Synkroniseringer:
        return 'Åbn synkronisering';
      case FeatureName.Adgange:
        return 'Åbn adgang';
      default:
        return 'Åbn';
    }
  }
}
